__turbopack_context__.v({
  "boardsMenu": "board-module__JP-plG__boardsMenu",
  "boardsMenuMobile": "board-module__JP-plG__boardsMenuMobile",
  "container": "board-module__JP-plG__container",
  "containerTopSpacing": "board-module__JP-plG__containerTopSpacing",
  "fadeInItems": "board-module__JP-plG__fadeInItems",
  "headerImage": "board-module__JP-plG__headerImage",
  "headerItem": "board-module__JP-plG__headerItem",
  "layout": "board-module__JP-plG__layout",
  "logo": "board-module__JP-plG__logo",
  "slideBelowMenu": "board-module__JP-plG__slideBelowMenu",
  "slider": "board-module__JP-plG__slider",
  "spacing--lg": "board-module__JP-plG__spacing--lg",
  "spacing--md": "board-module__JP-plG__spacing--md",
  "spacing--sm": "board-module__JP-plG__spacing--sm",
  "spacing--xl": "board-module__JP-plG__spacing--xl",
  "spacing--xs": "board-module__JP-plG__spacing--xs",
  "spacing--xxl": "board-module__JP-plG__spacing--xxl",
  "spacing--xxs": "board-module__JP-plG__spacing--xxs",
  "spacing--xxxl": "board-module__JP-plG__spacing--xxxl",
  "spacing--xxxs": "board-module__JP-plG__spacing--xxxs",
});
